import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { Estimativa } from 'src/app/models/Estimativa';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-dashboard-container',
  templateUrl: './dashboard-container.component.html',
  styleUrls: ['./dashboard-container.component.css']
})
export class DashboardContainerComponent implements OnInit {

  variables: any;

  colorBlue = "#0596FF";
  colorWhite = "#fff";
  colorBlack = "#000";

  estimativaArray: Estimativa[] = [];
  displayedColumns = ['ID', 'name', 'tecnologia', 'data_i', 'data_f', 'project', 'state'];

  constructor(
    private projectsService: ProjectsService,
    private route: ActivatedRoute,
    private router: Router,
    private apiEstimativaService: ApiEstimativaService,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((data: any) => {
      this.variables = data;
    });
  }

  goTo(place: string): void {
    this.router.navigate(['/' + place]);
  }
}
